import {Fragment, useContext, useEffect, useState} from 'react';
import {Typography, ListItemText, List, ListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GoogleLogin } from '@react-oauth/google';
import { UserContext } from '../contexts/UserContext';
import c4ulogo from "../assets/logo.png";
import Footer from './Layout/Footer';
import {jwtDecode} from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import useLog from '../hooks/useLog';


const Login = () => {
    const { t } = useTranslation();
    const { login, loggedInState } = useContext(UserContext);
    const navigate = useNavigate();
    const { LogInfo } = useLog();
    const [loginError, setLoginError] = useState(false);

    useEffect(() => {
        async function checkState() {
            LogInfo(`Login page loaded, logged in state: ${loggedInState}`);
            switch (loggedInState) {
                case 'Unauthenticated':
                    navigate('/login');
                    break;
                case 'CMSAuthenticated':
                    setLoginError(false);
                    navigate('/');
                    break;
                default:
                    break;
            }
        }
        checkState();
    }, [loggedInState]);

    const handleLogin = async (credentialResponse) => {
        setLoginError(false);
        LogInfo("Google login successful, JWT token: " + credentialResponse.credential);
        const details = jwtDecode(credentialResponse.credential);
        const loginResult = await login(details);
        console.log("Login result: " + loginResult);
        setLoginError(!loginResult);
    };
    
    return (
    <Fragment>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <List className='list-container'
                sx={{
                    pt: 0,
                    bgcolor: 'background.paper',
                    boxShadow: 3,
                    minWidth: 400,
                    width: '400px',
                    marginBottom: 2,
                }}>
                <ListItem sx={{backgroundColor:"grey.200"}}>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                        <img src={c4ulogo} alt="Connect4U Logo" style={{height: "60px", width: "60px", p:2}}></img>
                        <Typography variant="h4" color="GrayText" sx={{p:2}}> Connect 4U</Typography>
                    </div>
                </ListItem>
                <ListItem sx={{backgroundColor:"grey.200"}}>
                <ListItemText sx={{textAlign:"center"}}>
                    <Typography variant='h5' color={'GrayText'}>{t('c4uguard')}</Typography></ListItemText>
                </ListItem>
                {loginError && 
                    <ListItem sx={{backgroundColor:"red", textAlign:"center"}}  >
                        <Typography  variant='h5' color={'black'}  sx={{ textAlign: 'center' }}>{t('loginError')}</Typography>
                    </ListItem>
                }
                <ListItem >
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', width: '100%', direction: 'ltr' }}>
                        <GoogleLogin
                                onSuccess={(credentialResponse) => {
                                    handleLogin(credentialResponse);}}
                                onError={() => {console.log("Login Failed");
                                    setLoginError(true);}
                                }
                        />
                    </div>
                </ListItem>
            </List>
        </div>
        <Footer/>
        </Fragment>
    );
};

export default Login;